import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const downloadFile = createAsyncThunk(
  'general/downloadFile',
  async ({ type, filter }, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, `/general/file/download/${type}`, { filter });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const clearDownloadFile = createAction('clearDownloadFile');

export default downloadFile;
